import {
  SHOW_MODAL,
  HIDE_MODAL,
} from "./constants";
import {
  ModalShowAction,
  ModalHideAction,
} from "./actionTypes";

export function showModal(modalType: string, modalProps?: object): ModalShowAction {
  return {
    type: SHOW_MODAL,
    payload: {
      modalType,
      modalProps,
    },
  }
}

export function closeModal(): ModalHideAction {
  return ({
    type: HIDE_MODAL,
  });
}
